document.addEventListener("DOMContentLoaded", function() { 
  const popup = document.querySelector("#pays-popup"); 
  const menuLinks = document.querySelectorAll('a[href="/pays-popup"]'); // <- ici
  const closeBtn = popup.querySelector(".popup-close"); 

  if (!menuLinks.length || !popup || !closeBtn) return; 

  menuLinks.forEach(link => { 
    link.addEventListener("click", (e) => { 
      e.preventDefault(); 
      popup.classList.remove("hidden"); 
      // Ici tu peux ajouter la logique pour fermer le drawer mobile
    }); 
  }); 

  closeBtn.addEventListener("click", () => { 
    popup.classList.add("hidden"); 
  }); 

  popup.addEventListener("click", (e) => { 
    if (e.target === popup) popup.classList.add("hidden"); 
  }); 
});

